import type { Tile } from '../../../engine/hex/types';
import type { ContentBuilder } from '../../ui/ContentBuilder';
import { t } from '../../../i18n/translations';
import type { Language } from '../../../i18n/translations';

export function renderTileRawTab(builder: ContentBuilder, tile: Tile, lang: Language): void {
    builder.section(t(lang, 'tile.rawJson'), (section) => {
        section.jsonBlock(tile);
    });
}
